import { Client } from '../../domain/client/Client';
import { TableColumn, parseDefaultTableColumns } from '../shared/tableColumns';

export const clientsTableColumnKeys = [
  // `icon` |
  `label`,
  `external_id`,
  `location`,
  `location_details`,
  `comments`,
  `phone`,
  `email`,
  `url`,
  `reference_person`,
  `default_duration`,
  `default_weight`,
  `default_volume`,
  // `default_reward`
  `default_requires`,
  `default_cluster`,
  // `default_assign_to`
  `default_time_windows`,
  // `custom_fields`
  `created_at`,
] as const;

export type ClientsTableColumnKeys = (typeof clientsTableColumnKeys)[number];

export type ClientsTableColumn = TableColumn<ClientsTableColumnKeys, Client>;

export const CLIENTS_DEFAULT_TABLE_COLUMNS: Array<ClientsTableColumn> = [
  // icon: false,
  {
    identifier: `label`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `external_id`,
    type: `string`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `location`,
    type: `Location`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `location_details`,
    type: `string`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `comments`,
    type: `string`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `phone`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `email`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `url`,
    type: `string`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `reference_person`,
    type: `string`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_duration`,
    type: `number`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_weight`,
    type: `number`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_volume`,
    type: `number`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  // default_reward: false,
  {
    identifier: `default_requires`,
    type: `Array`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  {
    identifier: `default_cluster`,
    type: `string`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  // default_assignTo: false,
  {
    identifier: `default_time_windows`,
    type: `string`,
    displayable: false,
    filterable: true,
    sortable: true,
  },
  // custom_fields: false,
  {
    identifier: `created_at`,
    type: `Date`,
    displayable: true,
    filterable: true,
    sortable: true,
  },
];

export const getClientsTableColumns = (): Array<ClientsTableColumn> => {
  const storedTableColumns = localStorage.getItem(`CLIENTS_TABLE_COLUMNS`);
  if (!storedTableColumns) return CLIENTS_DEFAULT_TABLE_COLUMNS;

  const parsedTableColumns = JSON.parse(storedTableColumns);

  // Final table columns should have the current ones.
  const finalTableColumns: Array<ClientsTableColumn> = [
    ...(Array.isArray(parsedTableColumns) ? parsedTableColumns : []),
  ];

  return parseDefaultTableColumns({
    finalTableColumns,
    defaultTableColumns: CLIENTS_DEFAULT_TABLE_COLUMNS,
  });
};

export const setClientsTableColumns = (tableColumns: Array<ClientsTableColumn>) => {
  localStorage.setItem(`CLIENTS_TABLE_COLUMNS`, JSON.stringify(tableColumns));
};
